import clsx from 'clsx';
import React from 'react';
import {Box, Button} from '@mui/material';
import translate from '@/utils/translate';
import type {CampaignTab} from '@/types/campaignTab';
import NavLink from '@/components/nav-link';
import useEmberModalsStackStore from '@/stores/emberModalsStackStore';
import styles from './CampaignTabs.module.scss';

interface CampaignTabsProps {
  tabs: CampaignTab[];
  testID?: string;
  showOpenBriefButton?: boolean;
  onOpenBrief?: () => void;
  rightSlot?: React.ReactNode;
}

function CampaignTabs({
  tabs,
  testID = 'campaign-tabs',
  showOpenBriefButton,
  onOpenBrief,
  rightSlot,
}: CampaignTabsProps) {
  const {modalsStack: emberModalsStack} = useEmberModalsStackStore();
  const zIndex = emberModalsStack.length ? 0 : 10;

  return (
    <Box
      className={styles.navigationContainer}
      data-testid={testID}
      sx={{zIndex}}
    >
      <Box component="ul" className={styles.tabList}>
        {tabs.map((tab) => (
          <Box key={tab.id} component="li" className={styles.tabItem}>
            {tab.disabled ? (
              <Box
                component="span"
                className={clsx(styles.navLink, styles.active)}
              >
                {tab.label}
              </Box>
            ) : (
              <NavLink
                to={tab.path}
                testID={`campaign-navigation-${tab.testID}`}
                className={({isActive}) =>
                  clsx(styles.navLink, isActive && styles.active)
                }
              >
                {tab.label}
                {tab.showUnreadIndicator && (
                  <Box
                    className={styles.unreadIndicator}
                    data-test-unread-indicator={tab.testID}
                  />
                )}
              </NavLink>
            )}
          </Box>
        ))}
      </Box>
      {showOpenBriefButton && (
        <Box className={styles.buttonContainer}>
          <Button
            variant="outlined"
            size="small"
            className={styles.openBriefButton}
            onClick={onOpenBrief}
          >
            {translate('Open brief')}
          </Button>
        </Box>
      )}
      {rightSlot && <Box className={styles.rightSlot}>{rightSlot}</Box>}
    </Box>
  );
}

export default CampaignTabs;
